import React from 'react';
import './Smm.css';

const Smm = () => {
  return (
    <div className="smm-services">
      <section className="smm-hero">
        <h4>SMM SERVICES</h4>
        <h2>Social Media Marketing Services</h2>
        <button className="smm-cta-button">Get in Touch</button>
        <div className="smm-why-invest">
          <h3>WHY INVEST IN SMM</h3>
          <p>
            Social Media Marketing (SMM) is a cost-effective and high-impact way to increase brand visibility, web traffic, and sales revenue.
          </p>
          <p>
            Our expert team helps elevate your brand by crafting engaging content, building audience trust, and using data-driven insights to drive growth across all platforms.
          </p>
        </div>
      </section>

      <section className="smm-benefits">
        <h4>BEST FOR YOU</h4>
        <h2>How Our SMM Team Can Help</h2>
        <p>We create results-driven campaigns using proven strategies, powerful content, and data-backed insights.</p>
        <div className="smm-benefits-grid">
          <div className="smm-benefit-card">
            <h3>01 Media Promotion</h3>
            <p>We design engaging ad campaigns and collaborate with influencers to expand reach and increase audience interaction. Metrics are tracked continuously.</p>
          </div>
          <div className="smm-benefit-card">
            <h3>02 E-commerce SEO</h3>
            <p>We optimize social content to improve visibility on search engines. Our backlinks and signals help elevate your online store’s performance.</p>
          </div>
          <div className="smm-benefit-card">
            <h3>03 Penalty Recovery</h3>
            <p>We rebuild your online presence through positive content, engagement, and strategic campaigns—restoring trust and organic traffic.</p>
          </div>
          <div className="smm-benefit-card">
            <h3>04 Infographics Content</h3>
            <p>We create visually impactful infographics that clarify complex topics and boost shareability across platforms—driving more awareness.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Smm;
